import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=def5d650&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('def5d650')) {
      api.createRecord('def5d650', component.options)
    } else {
      api.reload('def5d650', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=def5d650&", function () {
      api.rerender('def5d650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Leads/Tabs/Info.vue"
export default component.exports